/* eslint-disable array-callback-return */
import React, { useEffect, useState } from "react";
import PayCard from "./payCard";
import { connect } from "react-redux";
import { useParams, useLocation } from "react-router-dom";
import {
	updateKeyShop,
	editShops,
	updateSettings,
	updatePayCard,
} from "../../reducers/shops";
import { withFirebase } from "../../firebase";

const PayCardContainer = ({
	updateKeyShop,
	editShops,
	updateSettings,
	updatePayCard,
	firebase,
	shops,
	closedAlert,
	appSettings,
	adminPermission,
}) => {
	const { city } = useParams();
	const [checked, setChecked] = useState(false);
	const [loadStatus, setLoadStatus] = useState(false);
	const [cityData, setCityData] = useState([]);

	// три состояния
	const [statusPayment, setStatusPayment] = useState(false);
	const [statusDelivery, setStatusDelivery] = useState(false);
	const [statusPickup, setStatusPickup] = useState(false);
	const [statusCash, setStatusCash] = useState(false);

	const cityIndex = localStorage.getItem("chosenCity");
	const brand = localStorage.getItem("chosenBrand");
	const location = useLocation();

	useEffect(() => {
		getStatuses();
	}, [location]);

	const getStatuses = () => {
		const isDebug = JSON.parse(localStorage.getItem("isDebug"));
		const basePath = `${
			isDebug ? "debug" : ""
		}/settings/city/${cityIndex}/brands/${brand}/checkoutScreen`;

		firebase.bd.ref(`${basePath}/isCardAvailable`).on("value", (snapshot) => {
			setStatusPayment(snapshot.val());
		});

		firebase.bd
			.ref(`${basePath}/isCardOnlineForDeliveryAvailable`)
			.on("value", (snapshot) => {
				setStatusDelivery(snapshot.val());
			});

		firebase.bd
			.ref(`${basePath}/isCardOnlineForPickupAvailable`)
			.on("value", (snapshot) => {
				setStatusPickup(snapshot.val());
			});
		firebase.bd.ref(`${basePath}/isCashAvailable`).on("value", (snapshot) => {
			console.log(snapshot.val());
			setStatusCash(snapshot.val());
		});
	};

	const updateStatus = (key, currentValue) => {
		const isDebug = JSON.parse(localStorage.getItem("isDebug"));
		const basePath = `${
			isDebug ? "debug" : ""
		}/settings/city/${cityIndex}/brands/${brand}/checkoutScreen`;

		firebase.bd
			.ref(basePath)
			.update({ [key]: !currentValue })
			.catch((error) => {
				console.error(`Failed to update ${key}:`, error);
			});
	};

	return (
		<>
			<PayCard
				updateStatusApp={() => updateStatus("isCardAvailable", statusPayment)}
				statusPayment={statusPayment}
				updateStatusDelivery={() =>
					updateStatus("isCardOnlineForDeliveryAvailable", statusDelivery)
				}
				statusDelivery={statusDelivery}
				updateStatusPickup={() =>
					updateStatus("isCardOnlineForPickupAvailable", statusPickup)
				}
				updateStatusCash={() => updateStatus("isCashAvailable", statusCash)}
				statusCash={statusCash}
				statusPickup={statusPickup}
				loadStatus={loadStatus}
				closedAlert={closedAlert}
				shops={shops[cityIndex]?.brands[brand]}
				city={cityData}
				editShops={editShops}
				checked={checked}
				payCardForDeliveryPickup={adminPermission?.payCardForDeliveryPickup}
			/>
		</>
	);
};

const mapStateToProps = (state) => ({
	shops: state.shops.shops,
	adminPermission: state.shops.adminPermission,
	appSettings: state.shops.appSettings,
});

export default connect(mapStateToProps, {
	updateKeyShop,
	editShops,
	updateSettings,
	updatePayCard,
})(withFirebase(PayCardContainer));
